import { setResponseHeaders } from 'h3'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) {
    const event = useRequestEvent()
    if (event) {
      setResponseHeaders(event, {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      })
    }
  }
})

